// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const SELECTED_TARGETS_ACTION_SUBTYPE = "MODERATION";
export const SELECTED_TARGETS_STORE_PATH = "moderation.selectedTargets";
